import { ChangeDetectionStrategy, Component, inject, OnInit, signal, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ProductService } from '../../services/product.service';
import type { ProductListItemDto } from '@api/models';
import { onWindowLoad } from '../../helpers/on-window-load.function';
import { ProductsPreviewComponent } from '../products-preview/products-preview.component';
import { CartModalComponent, CartModalData } from '../cart-modal/cart-modal.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'recently-added-products',
  templateUrl: './recently-added-products.component.html',
  styleUrls: ['./recently-added-products.component.scss'],
  imports: [ProductsPreviewComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecentlyAddedProductsComponent implements OnInit {
  private productService = inject(ProductService);
  private destroyRef = inject(DestroyRef);
  private dialog = inject(MatDialog);

  recentlyAddedProducts = signal<ProductListItemDto[] | undefined>(undefined);
  protected readonly sourceForAnalytics = 'recently_added_products';

  ngOnInit(): void {
    onWindowLoad(() => this.fetchRecentlyAddedProducts());
  }

  showCart(_productId: number): void {
    this.dialog.open<CartModalComponent, CartModalData>(
      CartModalComponent,
      { data: { sourceForAnalytics: this.sourceForAnalytics } },
    );
  }

  private fetchRecentlyAddedProducts(): void {
    this.productService.fetchRecentlyAddedProducts()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        response => this.recentlyAddedProducts.set(response.data)
      );
  }
}
